import { defineStore } from 'pinia'
import api from '@/api/axios'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    accessToken: localStorage.getItem('accessToken') || null,
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    initialized: false
  }),

  getters: {
    isAuthenticated: (state) => !!state.accessToken,

    isAdmin: (state) =>
      ['SUPER_ADMIN', 'ADMIN', 'OPERATOR'].includes(state.user?.roleCode),

    isClientLike: (state) =>
      ['USER', 'MONITOR'].includes(state.user?.roleCode),
  },

  actions: {
    setAuth(data) {
      this.accessToken = data.accessToken
      this.user = data.user
      this.initialized = true

      localStorage.setItem('accessToken', data.accessToken)
      localStorage.setItem('user', JSON.stringify(data.user))
    },

    async login(payload) {
      const response = await api.post('/auth/login', payload)
      const data = response.data

      if (!data?.success || !data?.accessToken) {
        throw new Error('로그인 응답이 올바르지 않습니다.')
      }

      this.setAuth(data)
      return data
    },

    async fetchMe() {
      if (!this.accessToken) {
        this.initialized = true
        return null
      }

      const response = await api.get('/auth/me')
      const data = response.data

      if (data?.success) {
        this.user = {
          id: data.id,
          username: data.username,
          roleCode: data.roleCode,
          roleName: data.roleName
        }

        this.initialized = true
        localStorage.setItem('user', JSON.stringify(this.user))
        return data
      }

      return null
    },

    logout() {
      this.accessToken = null
      this.user = null
      this.initialized = true

      localStorage.removeItem('accessToken')
      localStorage.removeItem('user')
    },
  },
})